import { createSvg } from '../createSvg';

const One = (
    {
        strokeWidth = 1.5,
    },
): JSX.Element => {
    return (
        <>
            <g id={'contour'}>
                <path
                    d='M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z'
                    strokeWidth={strokeWidth}
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </g>
            <g id={'guts'}>
                <path d='M13.4879 14.6971V5.97712H10.7519L7.5359 7.83312L8.6719
            9.75312L11.0879 8.40912V14.6971H8.1119V16.8571H15.8879V14.6971H13.4879Z'
                />
            </g>
        </>
    );
};

export default createSvg(
    One,
    'one',
);
